'use strict';

define('vb/private/stateManagement/layoutTranslationsMixin',[
  'vb/helpers/mixin',
  'vb/private/constants',
  'vb/private/stateManagement/translationsMixin',
], (
  Mixin,
  Constants,
  TranslationsMixin,
) => {
  /**
   * Translations Mixin that should be used by all layout containers.
   */
  const LayoutTranslationsMixin = (superclass) => class extends Mixin(superclass).with(TranslationsMixin) {
    /**
     * V2 translations bundle resource name represented by '$default' bundle.
     * For convenience, omit the "-i18n" suffix to the resource name.
     *
     * @type {string}
     */
    get defaultBundleResourceName() {
      return this.resourceDescriptor && this.resourceDescriptor.defaultBundleResourceName;
    }

    /**
     * Location of local V2 translations bundles.
     * For convenience, omit the 'resources/translations/' suffix to the path location.
     *
     * @type {string}
     */
    get translationsLocation() {
      // If BOSS metadata, the metadata provider helper will have additional i18n configuration information
      // for the BOSS module.
      const i18n = (this.resourceDescriptor && this.resourceDescriptor.i18n) || {};
      return i18n.location || `${Constants.DefaultPaths.LAYOUTS}${Constants.ExtensionFolders.SELF}/`;
    }
  };

  return LayoutTranslationsMixin;
});

